/**
 * Enum for primary step IDs
 *
 * These IDs are the UI-internal kebab-case keys used inside the workflow
 * (WorkflowFormData, workflowConfig.steps, STEP_TO_API_SECTION keys, etc.).
 *
 * They are intentionally NOT the API section names. The API
 * (NOVAApplicationDataSchema) uses camelCase section keys. The bridge
 * between these UI keys and the API sections lives in STEP_TO_API_SECTION
 * in context/application-map.ts — never send these values to the API
 * without going through that mapping.
 */
export enum PrimaryStep {
  CITIZENSHIP_DETAILS = 'citizenship-details',
  CONFIRMATION = 'confirmation',
  CONTRACT_DETAILS = 'contract-details',
  DOCUMENT_UPLOAD = 'document-upload',
  FINAL_REVIEW = 'final-review',
  OF_306_QUESTIONS = 'of-306-questions',
  PERSONAL_DETAILS = 'personal-details',
}

/**
 * Enum for sub-step IDs
 *
 * These IDs are the UI-internal kebab-case keys used as field-group
 * keys inside each primary step's WorkflowFormData slot. They are
 * form-side only and do not appear in the API payload — the form
 * builder reads `formData[PrimaryStep.X]?.[SubStep.Y]` and flattens
 * the fields into the API section shape (see
 * context/application-map.ts formDataToApplicationData).
 */
export enum SubStep {
  ADDRESS_INFO = 'personal-address',
  BASIC_INFO = 'basic-info',
  BIRTH_INFORMATION = 'birth-information',
  CERTIFICATION = 'certification',
  CITIZENSHIP_STATUS = 'citizenship-status',
  COMPLETION = 'completion',
  CONTACT_INFO = 'contact-info',
  CONTRACT_INFO = 'contract-info',
  COURT_MARTIAL = 'court-martial',
  CRIMINAL_CORRECTION = 'criminal-correction',
  CURRENT_VIOLATIONS = 'current-violations',
  FEDERAL_DEBT = 'federal-debt',
  IMMIGRATION_DOCUMENT = 'immigration-document',
  JOB_DISMISSAL = 'job-dismissal',
  MILITARY_EXPERIENCE = 'military-experience',
  PASSPORT_INFORMATION = 'passport-information',
  RELATIVES = 'relatives',
  RESIDENCY_INFORMATION = 'residency-information',
  RETIREMENT_PAY = 'retirement-pay',
  REVIEW_APPLICATION = 'review-application',
  SELECTIVE_SERVICE = 'selective-service',
  UPLOAD_DOCUMENTS = 'upload-documents',
  US_ENTRY_INFORMATION = 'us-entry-information',
  WORK_CONTACT_INFO = 'work-contact-info',
}
